import { selectPath } from './selectPath';
import { IApplicationState } from '../../types/redux';

/** Страница «Топ-10 предложений» / «Лучшие ипотечные предложения» */
export const selectIsBestMortgageOffersPage = (state: IApplicationState): boolean => {
  return selectPath(state).includes('luchshie-predlozheniya');
};
